import React from "react";
import moment from "moment";
const BikeRegister = ({ register }) => {
  let data = register;

  return (
    <div>
      <p>
        Nombre titular: <strong>{data.ownerName}</strong>
      </p>
      <p>
        DNI: <strong>{data.ownerDNI} </strong>
      </p>
      <div class="ui divider"></div>
      <p>
        Numero de cuadro: <strong>{data.bikeChasisNumber}</strong>
      </p>
      <p>Marca:{data.bikeBrand}</p>
      <p>Modelo: {data.bikeModel}</p>
      <div class="ui divider"></div>
      <p>Nº Factura: {data.receiptNumber}</p>
      <p>
        Fecha:{" "}
        {moment(data.purchaseDate)
          .utc()
          .format("DD/MM/YYYY")}{" "}
      </p>
    </div>
  );
};

export default BikeRegister;
